.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-muted);
  touch-action: manipulation;
}

.trigger:hover,
.trigger[aria-expanded='true'] {
  background: var(--surface-muted);
  color: var(--text);
}

.trigger:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

@media (pointer: coarse) {
  .trigger {
    width: 44px;
    height: 44px;
  }
}

.menu {
  position: fixed;
  z-index: 60;
  min-width: 140px;
  max-width: calc(100vw - 16px);
  padding: 4px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-pop);
}

.item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(--control-h);
  padding: 0 12px;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text);
  text-align: left;
  white-space: nowrap;
}

.item:hover,
.item:focus-visible {
  background: var(--surface-muted);
  outline: none;
}

.item:focus-visible {
  box-shadow: inset 0 0 0 2px var(--accent);
}

.danger {
  color: var(--danger);
}

.danger:hover,
.danger:focus-visible {
  background: var(--danger-soft);
}

.item[aria-disabled='true'] {
  color: var(--text-muted);
  cursor: not-allowed;
}

.item[aria-disabled='true']:hover {
  background: transparent;
}
